import { render } from "./VueMp.vue?vue&type=template&id=2f1973ff"
import script from "./VueMp.vue?vue&type=script&lang=js"
export * from "./VueMp.vue?vue&type=script&lang=js"

import "./VueMp.vue?vue&type=style&index=0&id=2f1973ff&lang=css"

import exportComponent from "/home/runner/work/fomofinal/fomofinal/fomoapp/frontend3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__